import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IDxCategory, IDxIcdCodes, IDXDetails } from 'src/app/models/IDXDetails';
import { IOrdersCategory, IOrdersCPTCodes, ICptOrdersComponent, IOrdersDx, ICptOrdersCompDetails, IManualOrdersCPTCodes, IOrdersLoinc } from 'src/app/models/ICptOrdersComponent';
import { configuration } from 'src/environments/environment';
import { IOrdersFacilityProvider } from 'src/app/models/IOrdersFacilityProvider';
import { ImportOrderTrackers } from 'src/app/models/ImportOrderTrackers';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';

@Injectable({
  providedIn: 'root'
})
export class CptordersService {

  constructor(private http: HttpClient, private crypto: AESAlgorithm) { }

  getcptOrdersCategory(): Observable<IOrdersCategory[]> {
    return this.http.get<IOrdersCategory[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersCategory'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getDxIcdByEncId(encId: string, patId: number): Observable<IDXDetails[]> {
    return this.http.get<IDXDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/CPTICDFROMDX'}?encid=${encId}&&patid=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getOrdersCPTCodes(): Observable<IOrdersCPTCodes[]> {
    return this.http.get<IOrdersCPTCodes[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersCPT'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  addOrtderCPTInfo(orderCPTInfo: ICptOrdersCompDetails): Observable<ICptOrdersCompDetails> {
    const posteddata = {
      inputdata: JSON.stringify(orderCPTInfo)
    }
    return this.http.post<ICptOrdersCompDetails>(`${configuration.clinicapiUrl + 'Encounter/CptOrdersCompDetails'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getCPTOrderByEncId(encId: string, patId: number): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/CPTOrders'}?encid=${encId}&&patid=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getPatientCPTOrderByEncId(encId: string, patId: number): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatientCPTOrders'}?encid=${encId}&&patid=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getPatientAllCurrentCPTOrderByEncId(encId: string): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatientCurrentCPTOrders'}?encid=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getPatientAllCurrentCPTOrderByParameter(orderDate: Date, categoryId: number, facilityProviderId: number, orderId: number): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/CPTOrdersByParameter'}?orderDate=${orderDate}&&catId=${categoryId}&&facProId=${facilityProviderId}&&orderId=${orderId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getPatientAllCurrentCPTOrderByFacility(orderDate: Date, categoryId: number, facilityProviderId: number, orderId: number): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/CPTOrdersByfacility'}?orderDate=${orderDate}&&catId=${categoryId}&&facProId=${facilityProviderId}&&orderId=${orderId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  DeleteSelectOrderInfo(encId: string, Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/CPTOrders'}?encid=${encId}&&id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeletePatSelectOrderInfo(encId: string, Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/PatCPTOrders'}?encid=${encId}&&id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  //************* Orders Facility  */
  InsertOrdersFacilityInfo(ordersFacilityInfo: IOrdersFacilityProvider): Observable<IOrdersFacilityProvider> {
    const posteddata = {
      inputdata: JSON.stringify(ordersFacilityInfo)
    }
    return this.http.post<IOrdersFacilityProvider>(`${configuration.clinicapiUrl + 'Encounter/OrdersFacility'}?clientId=${Number(sessionStorage.getItem("FacilityId"))}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getOrdersFacilityInfo(): Observable<IOrdersFacilityProvider[]> {
    return this.http.get<IOrdersFacilityProvider[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersFacility'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&clientId=${Number(sessionStorage.getItem("FacilityId"))}`);
  }


  //************* Orders Facility Providers */
  InsertOrdersProvidersInfo(ordersFacilityInfo: IOrdersFacilityProvider): Observable<IOrdersFacilityProvider> {
    const posteddata = {
      inputdata: JSON.stringify(ordersFacilityInfo)
    }
    return this.http.post<IOrdersFacilityProvider>(`${configuration.clinicapiUrl + 'Encounter/OrdersProvider'}?facilityId=${Number(sessionStorage.getItem("FacilityId"))}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getOrdersProvidersInfo(): Observable<IOrdersFacilityProvider[]> {
    return this.http.get<IOrdersFacilityProvider[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersProvider'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAllOrdersFacilityProvidersDetails(): Observable<IOrdersFacilityProvider[]> {
    return this.http.get<IOrdersFacilityProvider[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersFacilityProvider'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`);
  }
  updateOrderFacilityProvidersInfo(ordersFacilityInfo: IOrdersFacilityProvider): Observable<IOrdersFacilityProvider> {
    return this.http.post<IOrdersFacilityProvider>(`${configuration.clinicapiUrl + 'Encounter/OrderFacilityProvider'}`, ordersFacilityInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteOrderFacilityProviderInfo(facilityId: number, providerId: number): Observable<number> {
    return this.http.put<number>(`${configuration.clinicapiUrl + 'Encounter/DeleteOrderFacilityProvider'}?facilityId=${facilityId}&&providerId=${providerId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //************* Import Orders Trackers  */

  InsertImportOrderTrackerInfo(importOrderTrackerInfo: FormData): Observable<ImportOrderTrackers> {
    return this.http.post<ImportOrderTrackers>(`${configuration.clinicapiUrl + 'Encounter/ImportOrderTracker'}`, importOrderTrackerInfo);
  }
  GetImportOrderTrackerInfo(cptOrderId: number): Observable<ImportOrderTrackers[]> {
    return this.http.get<ImportOrderTrackers[]>(
      `${configuration.clinicapiUrl + 'Encounter/ImportOrderTracker'}?cptOrderId=${cptOrderId}`);
  }

  getManualOrderDetails(encounterId: string, facilityProviderId: number, cptOrderId: string): Observable<IManualOrdersCPTCodes[]> {
    return this.http.get<IManualOrdersCPTCodes[]>(
      `${configuration.clinicapiUrl + 'Encounter/ImportManualOrderTracker'}?encounterId=${encounterId}&&facilityProviderId=${facilityProviderId}&&cptOrderId=${cptOrderId}`);
  }

  updateOrderTrackerStatus(orderCPTInfo: ICptOrdersComponent): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/OrderTrackerStatus'}`, orderCPTInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  updateImportOrderStatus(orderCPTInfo: ICptOrdersComponent): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/ImportOrderStatus'}`, orderCPTInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Multi Delete select Orders

  MultiDeleteSelectOrderInfo(encId: string, Id: number, catId: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/MultiDeleteCPTOrders'}?encid=${encId}&&id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&catId=${catId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getOrdersCPTCodesBySearch(text: any): Observable<IOrdersCPTCodes[]> {
    return this.http.get<IOrdersCPTCodes[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersCPTBySearch'}?text=${text}`);
  }

  GetICDCodes_AutocompleteSearch(text: any): Observable<any> {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'Encounter/GetICDCodes_AutocompleteSearch'}?text=${text}`);
  }

  getOrdersLoincCodes(encId: string): Observable<IOrdersLoinc[]> {
    return this.http.get<IOrdersLoinc[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersLoincData'}?encid=${encId}`);
  }

  saveLoincCategorydetails(cptInfo: IOrdersLoinc): Observable<string> {
    //const postedLoincInfo = Object.assign({}, cptInfo)
    const postedLoincInfo = {
      inputdata: JSON.stringify(cptInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/insertLoincCategorydetails'}?`, postedLoincInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteLoincOrderInfo(encId: string, code: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/DeleteLoincCategorydetails'}?encid=${encId}&&code=${code}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  
  getOrdersLoincMasterBySearch(text: any): Observable<IOrdersLoinc[]> {
    return this.http.get<IOrdersLoinc[]>(
      `${configuration.clinicapiUrl + 'Encounter/OrdersLoincBySearch'}?text=${text}`);
  }

  viewDocument(fileName: string, filePath: string): Observable<string> {
    return this.http.get<string>(`${configuration.apiUrl + 'Encounter/viewdocument'}?NewFileName=${encodeURIComponent(fileName)}&&UserId=${encodeURIComponent(sessionStorage.getItem("username")).toString()}`,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' }),
        params: { patharray: filePath }
      });
  }
}